import { Directive, TemplateRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[ngslCarouselItem]'
})
export class NgslCarouselItemDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
